import { FC, MutableRefObject, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { SCREEN_SIZE_BORDER } from 'constants/frontend-contsants';
import { OverviewItems } from '../overview-items';
import {
  creatorProfileSelector,
  creatorProfileRollPendingSelector,
  creatorProfileRollAssetsSelector,
  creatorProfileRollPreviewsSelector,
} from '../../store/creators.selectors';

import ImageList from '@mui/material/ImageList';
import AssetsListItem from './asset-list-item';
import useWindowDimensions from 'hooks/use-window-dimensions';
import useInfiniteScroll from 'hooks/use-infinite-scroll';

interface AssetsListProps {
  isConversationEnabled: boolean;
  handlePreviewOpen: (asset: any, index: number) => any;
  onScroll: () => void;
}

const AssetsList: FC<AssetsListProps> = ({
  isConversationEnabled,
  handlePreviewOpen,
  onScroll,
}) => {
  const triggerRef = useRef() as MutableRefObject<HTMLDivElement>;

  const { width } = useWindowDimensions();

  const pending_roll = useSelector(creatorProfileRollPendingSelector);
  const roll_assets = useSelector(creatorProfileRollAssetsSelector);
  const roll_previews = useSelector(creatorProfileRollPreviewsSelector);
  const profile = useSelector(creatorProfileSelector);

  const isToShowOverviewItems = useMemo(() => {
    return (
      width <= SCREEN_SIZE_BORDER && !profile?.isSubscribed && !pending_roll
    );
  }, [pending_roll, profile?.isSubscribed, width]);

  useInfiniteScroll({
    pending: pending_roll,
    callback: onScroll,
    triggerRef: triggerRef,
    wrapperElement: null,
  });

  if (!profile) {
    return <></>;
  }
  return (
    <>
      <ImageList
        variant="quilted"
        cols={3}
        gap={2}
        sx={{ margin: '4px 0', overflowY: 'hidden', gridAutoFlow: 'dense' }}
      >
        {roll_previews?.map((_aseets, index) =>
          _aseets?.map((asset) => (
            <AssetsListItem
              key={asset.content}
              asset={asset}
              handlePreviewOpen={handlePreviewOpen}
              index={index}
            />
          ))
        ) || <></>}

        {isToShowOverviewItems && (
          <OverviewItems
            isConversationEnabled={isConversationEnabled}
            profile={profile}
          />
        )}

        {roll_assets?.map((_aseets, index) =>
          _aseets?.map((asset) => (
            <AssetsListItem
              key={asset.content}
              asset={asset}
              handlePreviewOpen={handlePreviewOpen}
              index={index + roll_previews.length}
            />
          ))
        ) || <></>}
      </ImageList>
      <div ref={triggerRef} />
    </>
  );
};

export default AssetsList;
